@if (isInitialized) {
  <oe-navigation-view [title]="component.alias" [component]="component" [formGroup]="formGroup">
    <ion-buttons header class="ion-justify-content-center">
      <div #ref><ng-content select="[custom-pickdate]"></ng-content></div>
      @if (!ref.children.length) {
        <pickdate [historyPeriods]="['day', 'week']"></pickdate>
      }
    </ion-buttons>
    <oe-controller-evse-history-chart class="ion-padding" [component]="component">
    </oe-controller-evse-history-chart>
    @if (showStatusChart) {
      <oe-controller-evse-history-status-chart class="ion-padding ion-padding-bottom"
        [component]="component">
      </oe-controller-evse-history-status-chart>
    }
  </oe-navigation-view>
}
